<template>
    <div class="columns">
        <div class="column">
            <section class="section">
                <h1 class="title">Reports</h1>
                <h2 class="subtitle">Select the annual report you would like to download.</h2>
                <div class="container">
                    <file-list :files="reports" :show-date="false" :show-details="false" :loading="!loaded"></file-list>
                    <p v-if="loaded && reports.length === 0">No reports are currently shared.</p>
                </div>
            </section>
        </div>
        <div class="column">
            <section class="section">
                <div class="columns">
                    <div class="column is-three-quarters">
                        <h1 class="title">Data</h1>
                        <h2 class="subtitle">Select the data set you would like to view.</h2>
                    </div>
                    <div class="column is-one-quarter">
                        <div class="control">
                            <label class="label" for="organization-select">Filter by organization</label>
                            <div class="select">
                                <select id="organization-select" v-model="selectedOrganization" required>
                                    <option value="">all</option>
                                    <option v-for="organization in organizations" v-bind:key="organization.id" :value="organization.id">{{organization.name}}</option>
                                </select>
                            </div>
                        </div> 
                    </div>
                </div>
                <div class="container">
                <hr class="v1" style="left:-3ch;">
                    <file-list :files="filteredFiles" :auto-preview="true" :show-date="false" :show-details="false" :loading="!loaded"></file-list>
                    <p v-if="loaded && filteredFiles.length === 0">No data is currently shared.</p>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import BButton from "buefy/src/components/button/Button";
    import {mapGetters, mapState} from "vuex";
    import FileList from "../components/FileList";

    export default {
        data: () => ({
            'selectedOrganization': '',
        }),
        name: "ListReports",
        components: {FileList, BButton},
        computed: {
            ...mapGetters('files', [
                'datasets',
                'reports',
            ]),
            ...mapState('files', [
                'loaded',
            ]),
            ...mapState('user', [
                'organizations',
            ]),
            filteredFiles() {
                if (!this.selectedOrganization) {
                    
                    // If no organization is selected, return all files
                    return this.datasets;
                }
                // Return only files that belong to the selected organization
                return this.datasets.filter(file => file.Organization === this.selectedOrganization);
            }
        },
        mounted()  {
            this.$store.dispatch('files/getFiles');
        }
    }
</script>

<style scoped>

</style>